import React, { useState } from "react";
import AddGold from "./addProductTypes/addGold";
import AddDiamond from "./addProductTypes/addDiamond";
import {
  Box,
  Container,
  Paper,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  Divider,
} from "@mui/material";
import { Diamond as DiamondIcon, WorkspacePremium as GoldIcon } from "@mui/icons-material";

const Index = () => {
  const [addType, setAddType] = useState("Gold");

  return (
    <Box
      sx={{
        width: '100%',
        minHeight: '100vh',
        bgcolor: 'grey.50',
        pt: 2
      }}
    >
      <Container
        maxWidth={false}
        sx={{
          maxWidth: '1600px',
          mx: 'auto',
          px: { xs: 2, sm: 3, md: 4 },
        }}
      >
        <Paper
          elevation={0}
          sx={{
            p: { xs: 2, sm: 3, md: 4 },
            borderRadius: 2,
            border: '1px solid',
            borderColor: 'divider',
            bgcolor: 'background.paper',
          }}
        >
          {/* Başlık ve Seçim Alanı */}
          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h5"
              color="primary.main"
              sx={{
                mb: 3,
                fontWeight: 600
              }}
            >
              Yeni Ürün Ekle
            </Typography>

            <RadioGroup
              row
              value={addType}
              onChange={(e) => setAddType(e.target.value)}
              sx={{
                display: 'flex',
                gap: 4
              }}
            >
              <Paper
                elevation={addType === "Gold" ? 2 : 0}
                sx={{
                  flex: 1,
                  p: 2,
                  cursor: 'pointer',
                  border: '1px solid',
                  borderColor: addType === "Gold" ? 'primary.main' : 'divider',
                  borderRadius: 2,
                  transition: 'all 0.2s',
                  '&:hover': {
                    borderColor: 'primary.main',
                    transform: 'translateY(-2px)'
                  }
                }}
                onClick={() => setAddType("Gold")}
              >
                <FormControlLabel
                  value="Gold"
                  control={<Radio />}
                  label={
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Typography
                        variant="subtitle1"
                        color={addType === "Gold" ? "primary" : "text.primary"}
                      >
                        Altın Ürün
                      </Typography>
                    </Box>
                  }
                  sx={{ m: 0 }}
                />
              </Paper>

              <Paper
                elevation={addType === "Diamond" ? 2 : 0}
                sx={{
                  flex: 1,
                  p: 2,
                  cursor: 'pointer',
                  border: '1px solid',
                  borderColor: addType === "Diamond" ? 'primary.main' : 'divider',
                  borderRadius: 2,
                  transition: 'all 0.2s',
                  '&:hover': {
                    borderColor: 'primary.main',
                    transform: 'translateY(-2px)'
                  }
                }}
                onClick={() => setAddType("Diamond")}
              >
                <FormControlLabel
                  value="Diamond"
                  control={<Radio />}
                  label={
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <DiamondIcon color={addType === "Diamond" ? "primary" : "action"} />
                      <Typography
                        variant="subtitle1"
                        color={addType === "Diamond" ? "primary" : "text.primary"}
                      >
                        Pırlanta Ürün
                      </Typography>
                    </Box>
                  }
                  sx={{ m: 0 }}
                />
              </Paper>
            </RadioGroup>
          </Box>

          <Divider sx={{ mb: 4 }} />

          {/* Form Alanı */}
          <Box>
            {addType === "Gold" ? (
              <AddGold />
            ) : addType === "Diamond" ? (
              <AddDiamond />
            ) : null}
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default Index;
